import styled from "styled-components";

export const SummaryMainWrapper = styled.div`
  margin: 16px 16px 0px;
  .fAWnjn {
    font-size: 18px;
  }
  .dcQLOz {
    margin-top: 0px;
  }
`;

export const SummaryIconWrapper = styled.div`
  margin: 4px 4px 0px 0px;
`;
